import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-productodetalle',
  templateUrl: './productodetalle.component.html',
  styleUrls: ['./productodetalle.component.css']
})
export class ProductodetalleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
